<template>
  <div class="page">
    <h3 class="header-title-mobile">
      <div v-for="(item, key) in headerTitle.items" :key="key">
        <span class="px-2" v-if="key !== 0">›</span>
        <router-link v-if="item.url" :to="item.url" class="text-dark">{{ item.title }}</router-link>
        <div v-else style="display: contents" class="text-dark">{{ item.title }}</div>
      </div>
    </h3>
    <div class="float-right">
      <router-link v-if="car && car.id" :to="`/maintenance/car/${car.id}/create`" class="btn btn-primary">
        <font-awesome-icon class="text-white" icon="plus" size="1x"/>
        Добавить ТО
      </router-link>
    </div>
    <ServiceShow :car="car" />
    <ul class="nav nav-tabs justify-content-left">
      <li class="nav-item">
        <a class="nav-link active" data-toggle="tab" href="#summary">Сводка</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" data-toggle="tab" href="#history">История</a>
      </li>
      <span class="tab-bar"></span>
    </ul>
    <div class="tab-content">
      <div class="tab-pane fade show active" id="summary">
        <table class="table plan-items-table d-none d-md-table">
          <thead>
            <th>Вид работы</th>
            <th>Дата/время последнего ТО</th>
            <th>Пробег на момент ТО, км</th>
            <th>Пробег после ТО, км</th>
            <th>Интервал, км</th>
            <th>Следующее ТО</th>
          </thead>
          <tbody v-if="car && car.servicePlan">
            <tr v-for="planItem in car.servicePlan" :key="planItem.name">
              <td>{{ planItem.name }}</td>
              <td>{{ toHumanFormat(fromUTCtranslate(planItem.datetime)) }}</td>
              <td>{{ planItem.total_odometer_stamp || '-' }}</td>
              <td>{{ afterService(planItem) }}</td>
              <td>{{ planItem.interval ? planItem.interval : 'не указан' }}</td>
              <td><ServiceState :distance="leftBeforeNext(planItem)" :afterService="afterService(planItem)" :interval="planItem.interval" /></td>
            </tr>
          </tbody>
        </table>
        <div v-if="car && car.servicePlan">
          <div class="mobile-table-view card mt-2 mb-2 p-2 d-md-none" v-for="planItem in car.servicePlan" :key="planItem.name">
            <table class="table borderless">
              <tbody>
              <tr>
                <td style="border-top: none">Вид работы</td>
                <td style="border-top: none">{{ planItem.name }}</td>
              </tr>
              <tr>
                <td>Дата/время последнего ТО</td>
                <td>{{ toHumanFormat(fromUTCtranslate(planItem.datetime)) }}</td>
              </tr>
              <tr>
                <td>Пробег на момент ТО, км</td>
                <td>{{ planItem.total_odometer_stamp || '-' }}</td>
              </tr>
              <tr>
                <td>Пробег после ТО, км</td>
                <td>{{ afterService(planItem) }}</td>
              </tr>
              <tr>
                <td>Интервал, км</td>
                <td>{{ planItem.interval ? planItem.interval : 'не указан' }}</td>
              </tr>
              <tr>
                <td>Следующее ТО</td>
                <td><ServiceState :distance="leftBeforeNext(planItem)" :afterService="afterService(planItem)" :interval="planItem.interval" /></td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <ul class="tab-pane history-pane fade loader" id="history">
        <li class="list-group-item history-item" v-for="service in carServices" :key="service.id">
          <span>Пробег: {{ service.total_odometer_stamp }} км</span>
          <span class="float-right" style="margin-right: 5px;">{{ service.datetime | diffForHumans }}
            <font-awesome-icon
              icon="trash-alt"
              size="1x"
              :style="{ color: 'gray', cursor: 'pointer' }"
              @click="deleteService(service)"
            />
          </span>
          <ul>
            <li v-for="work in service.serviceWorks" :key="work.id">
              {{ work.name }}
            </li>
            <li v-if="service.notes">
              {{ service.notes }}
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { djsMixin } from '@/mixins/djsMixin'
import ServiceShow from './ServiceShow'
import serviceApi from '../../api/service'
import serviceWorkApi from '../../api/serviceWork'
import ServiceState from '../../components/ServiceState'

export default {
  name: 'ServicePage',
  components: {
    ServiceShow,
    ServiceState
  },
  props: ['carId'],
  mixins: [djsMixin],
  data () {
    return {
      carServices: [],
      car: null
    }
  },
  computed: {
    ...mapState('maintenance/serviceCar', {
      isLoading: state => state.isLoading
    }),
    ...mapState('taxi', {
      headerTitle: state => state.title
    })
  },
  mounted () {
    this.loadData()
  },
  methods: {
    ...mapActions('maintenance/serviceCar', [
      'loadItem'
    ]),
    ...mapActions('taxi', [
      'setTitle'
    ]),
    loadData () {
      serviceWorkApi.getActiveServiceWorks()
        .then(serviceWorks => {
          this.loadItem({
            id: this.carId,
            expand: [
              'servicePlan',
              'lastState',
              'nextServiceRecord'
            ]
          })
            .then(response => {
              this.car = {
                ...response,
                servicePlan: serviceWorks.map(serviceWork => {
                  const searchedIndex = response.servicePlan.findIndex(el => el.id == serviceWork.id)
                  return searchedIndex === -1 ? serviceWork : response.servicePlan[searchedIndex]
                })
              }
            })
        })
      serviceApi.getItems({
        expand: 'serviceWorks',
        extra: {
          key: 'filter[and][][car_id]',
          value: this.carId
        },
        sort: '-datetime'
      })
        .promise
        .then(response => {
          this.carServices = response.items
        })
    },
    deleteService (service) {
      this.carServices = this.carServices.filter(x => x.id !== service.id)
      serviceApi.removeItem(service.id)
      this.loadData()
    },
    afterService (planItem) {
      if (!this.car.lastState || !this.car.lastState.totalOdometer ||
        !this.car.lastState.totalOdometer.value) {
        return 'н/д о пробеге'
      }

      if (!planItem.total_odometer_stamp) {
        return 'н/д'
      }

      return Math.ceil(this.car.lastState.totalOdometer.value / 1000) - planItem.total_odometer_stamp
    },
    leftBeforeNext (planItem) {
      if (!this.car.lastState || !this.car.lastState.totalOdometer ||
        !this.car.lastState.totalOdometer.value) {
        return null
      }

      if (!planItem.total_odometer_stamp) {
        return null
      }

      return planItem.interval - (Math.round(this.car.lastState.totalOdometer.value / 1000) - planItem.total_odometer_stamp)
    }
  },
  watch: {
    car: {
      handler (car, carOld) {
        if (car?.id && car?.id !== carOld?.id) {
          this.setTitle({
            items: [
              {
                title: 'Тех. обслуживание',
                url: '/maintenance'
              }, {
                title: car.brand + ' ' + car.model + ' ' + car.registration_plate
              }
            ]
          })
        }
      },
      immediate: true
    }
  }
}
</script>

<style scoped>
  .history-pane {
    padding-left: 0;
    padding-right: 0;
  }
  .row {
    margin-left: 0;
    margin-right: 0;
  }
  .tab-content {
    padding: 1rem 1rem 1rem 1rem;
  }
  .history-item {
    padding-left: min(1.60rem, 3%);
    padding-right: 2%;
  }

</style>
